import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';

const SelectEstadoNoLeInteresaPreServicio = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    isMulti
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const options = [
        {
            value: 'NO HAY UN PLAN ADECUADO PARA MI',
            label: 'NO HAY UN PLAN ADECUADO PARA MI',
        },
        {
            value: 'ME RESULTA CARO',
            label: 'ME RESULTA CARO',
        },
        {
            value: 'NO TENGO APURO EN CONTRATAR EL SERVICIO',
            label: 'NO TENGO APURO EN CONTRATAR EL SERVICIO',
        },
        {
            value: 'NO LE TENGO CONFIANZA',
            label: 'NO LE TENGO CONFIANZA',
        },
        {
            value: 'NO ME ASESORARON CORRECTAMENTE',
            label: 'NO ME ASESORARON CORRECTAMENTE',
        },
        {
            value: 'NECESITO CONSULTARLO CON OTRA PERSONA',
            label: 'NECESITO CONSULTARLO CON OTRA PERSONA',
        },
        {
            value: 'OTROS',
            label: 'OTROS',
        },
        {
            value: 'ESTOY CONSULTANDO PRECIOS/PROMOCIONES',
            label: 'ESTOY CONSULTANDO PRECIOS/PROMOCIONES',
        },
        {
            value: 'NO TIENEN PROMOCIONES',
            label: 'NO TIENEN PROMOCIONES',
        },
        {
            value: 'NO TIENE SERVICIOS ADICIONALES',
            label: 'NO TIENE SERVICIOS ADICIONALES',
        },
        {
            value: 'NO TENGO TC',
            label: 'NO TENGO TC',
        },
        {
            value: 'NO COTIZAN EN MONEDA NACIONAL',
            label: 'NO COTIZAN EN MONEDA NACIONAL',
        },
        {
            value: 'PLAZO DE ESPERA EN FECHA DE INSTALACION',
            label: 'PLAZO DE ESPERA EN FECHA DE INSTALACION',
        },
        {
            value: 'INSTALACION CANCELADA',
            label: 'INSTALACION CANCELADA'
        },
        {
            value: 'CANCELADO POR FALTA DE DOCUMENTACIÓN',
            label: 'CANCELADO POR FALTA DE DOCUMENTACIÓN'
        },
    ];

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? (isDarkMode ? '#90caf9' : '#fff') : isDarkMode ? '#e0e0e0' : '#000',
            background: state.isSelected ? (isDarkMode ? '#1a3a5c' : '#0364ff') : isDarkMode ? '#2d3a52' : '#fff',
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#e0e0e0',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none',
                border: isDarkMode ? '1px solid #fff' : 'none'
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#e0e0e0',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectEstadoNoLeInteresaPreServicio.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectEstadoNoLeInteresaPreServicio;